import { Button, Modal } from "semantic-ui-react";
import { ITableDto, tableDtoInit } from "../../../models/table";
import { TableComponent } from "./TableComponent";

interface TableViewModalProps {
    tableToOpen: ITableDto;
    setTableToOpen: (table: ITableDto) => void;
    data: string[][];
}

export const TableViewModal: React.FC<TableViewModalProps> = ({
    tableToOpen,
    setTableToOpen,
    data,
}) => {
    return (
        <Modal open={tableToOpen.guid !== ""} onClose={() => setTableToOpen(tableDtoInit)}>
            <Modal.Header>{tableToOpen.name}</Modal.Header>
            <Modal.Content className="table-data-container">
                <TableComponent tableData={data} />
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={() => setTableToOpen(tableDtoInit)} content="Close" />
            </Modal.Actions>
        </Modal>
    );
};
